import React from 'react';
import {connect} from 'react-redux';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {Link} from 'react-router-dom';
import {Container, Header, Loader, Icon, Segment, Button} from 'semantic-ui-react';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {ContentDispatch} from 'framework';
import ApiActions from 'go/actions/api';
import _ from 'lodash';
import {API_ORGS_LIST_GET_BY_ID_SUCCESS} from 'common/types';
import REST from 'go/requests/rest';
import {getTimestampNowISO} from 'common/utils';
import {isUserSelfSarSm} from 'go/security/permissions';
import {ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {isSAR} from 'go/security/permissions';
import {START_RFA_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';

export class RfaInitializeComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitOnBehalf: undefined,
      entityId: _.get(
        this.props,
        'match.params.fundingOpportunityId',
        _.get(this.props, 'match.params.categoryId')
      ),
      entityType: 'fo',
      organizations: [],
      isUsrSAR: isSAR(this.props.auth.permissions),
      applicationEntityId: null,
      foData: null,
    };
  }

  createApplicationEntity = async () => {
    const {applyToOrgId, applyForOrgId, context, auth} = this.props;
    const {foData, isUsrSAR} = this.state;
    const orgs = isUsrSAR ? context.orgsWithinState : context.orgs;

    let currentDate = getTimestampNowISO();
    const toOrg = _.find(context.orgs, (org) => org.orgEntityId == applyToOrgId);
    const forOrg = _.find(orgs, (org) => org.orgEntityId == applyForOrgId);

    let payloadToSend = {
      entityType: 'rfa',
      subOrgId: applyForOrgId,
      organizationId: applyToOrgId,
      status: 'pendingSubmission',
      statusDate: currentDate,
      statusTimestamp: currentDate,
      payload: {
        fundingOpportunityId: _.toInteger(_.get(foData, 'fundingOpportunityId')),
        organizationId: _.toInteger(applyToOrgId),
        subOrganizationId: _.toInteger(applyForOrgId),
        initiatorUserId: auth.userId,
        initiatedTimestamp: currentDate,
        orgDisplayName: _.get(toOrg, 'orgDisplayName'),
        subOrgDisplayName: _.get(forOrg, 'orgDisplayName'),
      },
    };

    let additionalPayloadConfig = _.get(this.props, 'config.payload.additionalPayload');
    let additionalPayload = {};
    _.each(additionalPayloadConfig, (value, key) => {
      additionalPayload[key] = _.get(
        {props: this.props, entity: payloadToSend},
        value,
        value
      );
    });
    payloadToSend.payload = {
      ...payloadToSend.payload,
      ...additionalPayload,
    };

    payloadToSend.fundingOpportunityId = +this.props.match.params.fundingOpportunityId;
    payloadToSend.programId = +_.get(this.state, 'foData.programId');

    let jwt_token = this.props.jwt;

    return REST.dynamicData
      .createApplicationEntity(jwt_token, payloadToSend)
      .then((response) => response.json())
      .then((resJson) => {
        if (resJson) {
          this.setState((prevState) => ({
            ...prevState,
            applicationEntityId: resJson.entityId,
          }));
          return resJson;
        }
      })
      .catch((error) => {
        console.error('error');
      });
  };

  handleSubmit = () => {
    this.createApplicationEntity().then((resJson) =>
      this.props.history.push('/rfa/' + resJson.entityId)
    );
  };

  componentDidMount() {
    const {entityType, entityId, isUsrSAR} = this.state;
    let configType = 'entityEdit';
    let configId = 'rfaInitiation';
    let {getConfig} = this.props;
    const {postDynamicData, saveEntitySessionData} = this.props;

    getConfig(this.props.jwt, entityType, entityId, configType, configId).then(
      async (res) => {
        this.setState({config: res.payload});
        if (res) {
          let data = {};
          let config = res.payload;
          this.props.init(config, data, {
            apiCall: postDynamicData,
          });

          let foId = null,
            programId = null,
            foRestricted = null;

          const foData = await REST.fundingOpportunity
            .getFundingOpportunity(this.props.jwt, entityId)
            .then((res) => res.json())
            .catch((e) => console.error(e));

          if (foData) {
            (foId = foData.fundingOpportunityId),
              (programId = foData.programId),
              (foRestricted = foData.restrictedFundingOpportunityFlag);

            this.setState({
              foData,
              loading: false,
            });

            // Getting organizations with same physical state location if user is SAR
            let stateToSearch = null;

            saveEntitySessionData('sessionData.isUsrSAR', isUsrSAR);
            saveEntitySessionData('sessionData.configId', 'rfa');

            if (isUsrSAR && !this.props.toggles?.includes('rfaFuzzySearch')) {
              stateToSearch = foData.disasterStateCd;

              await REST.organization
                .getOrganizationsByState(this.props.jwt, stateToSearch)
                .then((res) => res.json())
                .then((res) => {
                  if (res) {
                    const orgData = res.map((item) => {
                      const eft = !_.isEmpty(_.trim(item.eft))
                        ? _.trim(item.eft)
                        : _.trim(item.dunsPlus4);
                      const ueiPlusEft = item.uei + (!_.isEmpty(eft) ? '-' + eft : '');
                      const uei = item.uei ? ` | UEI-EFT: ${ueiPlusEft}` : '';
                      const getName = item.displayName + uei;

                      return {
                        legalName: getName,
                        displayName: getName,
                        organizationId: '' + item.organizationId,
                        entityId: item.organizationId,
                        isOrg: false,
                        orgDisplayName: item.displayName,
                        orgEntityId: '' + item.organizationId,
                      };
                    });
                    saveEntitySessionData('context.orgsWithinState', orgData);
                  }
                })
                .catch((e) => console.error(e));
            }
            saveEntitySessionData('fundingOpportunityData', foData);
          }

          // getMySubOrganizations takes jwt token, so no need to iterate over all orgs
          return new Promise((resolve, reject) => {
            REST.organization
              .getMySubOrganizations(this.props.jwt, foId, programId, foRestricted)
              .then(REST.handler.handleResponse)
              .then((res) => {
                if (res) {
                  const subOrgs = res.map((item) => {
                    let parentOrgs = item.parentOrganizations;
                    item = item.organization;
                    const eft = !_.isEmpty(_.trim(item.eft))
                      ? _.trim(item.eft)
                      : _.trim(item.dunsPlus4);
                    const ueiPlusEft = item.uei + (!_.isEmpty(eft) ? '-' + eft : '');
                    const uei = item.uei ? ` | UEI-EFT: ${ueiPlusEft}` : '';
                    const getName = item.displayName + uei;
                    let canHaveSuborgAndSelfSarSM = undefined;
                    if (_.get(this.props, 'userEntities') !== undefined) {
                      canHaveSuborgAndSelfSarSM = _.get(this.props, 'userEntities', [])
                        .filter((y) => {
                          return y.entityId === item.entityId;
                        })
                        .map((x) => {
                          return x.canHaveSuborganizations;
                        })[0];
                      if (canHaveSuborgAndSelfSarSM) {
                        canHaveSuborgAndSelfSarSM =
                          isUserSelfSarSm(
                            this.props.auth.permissions,
                            item.entityId,
                            ROLE_MAP.SUBMEMBER.code
                          ) ||
                          isUserSelfSarSm(
                            this.props.auth.permissions,
                            item.entityId,
                            ROLE_MAP.SUBAUTHREP.code
                          );
                      }
                    }
                    return {
                      legalName: getName,
                      displayName: getName,
                      organizationName: item.entityId,
                      entityId: item.entityId,
                      isOrg: false,
                      orgDisplayName: item.displayName,
                      orgEntityId: item.entityId,
                      parentOrgs: parentOrgs,
                      canHaveSuborgAndSelfSarSM: canHaveSuborgAndSelfSarSM,
                    };
                  });
                  resolve(subOrgs);
                }
                resolve([]);
              })
              .catch((error) => {
                console.error('error');
                resolve([]);
              });
          }).then((subOrgs) => {
            this.setState({orgs: subOrgs});
            this.props.saveEntitySessionData('context.orgs', subOrgs);
          });
        }
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    document.title = START_RFA_PAGE;
    if (
      !_.isEqual(prevProps.applyToOrgId, this.props.applyToOrgId) ||
      !_.isEqual(prevProps.applyForOrgId, this.props.applyForOrgId)
    ) {
      this.refreshData(prevState);
    }
  }

  refreshData(prevState) {
    const {jwt, applyForOrgId, applyToOrgId, saveEntitySessionData, context} = this.props;
    const {foData, isUsrSAR} = this.state;

    if (applyForOrgId && applyToOrgId) {
      let submitOnBehalf = undefined;
      if (applyForOrgId === applyToOrgId) {
        submitOnBehalf = 'self';
      } else {
        submitOnBehalf = 'applicant';
      }
      if (
        submitOnBehalf &&
        (prevState.submitOnBehalf === undefined ||
          submitOnBehalf !== prevState.submitOnBehalf)
      ) {
        this.setState({submitOnBehalf: submitOnBehalf});
      }

      //Saving orgDisplayName for validation message
      const orgs = isUsrSAR ? context.orgsWithinState : context.orgs;
      const toOrg = _.find(context.orgs, (org) => org.orgEntityId == applyToOrgId);
      const forOrg = _.find(orgs, (org) => org.orgEntityId == applyForOrgId);
      saveEntitySessionData('sessionData.applyToOrgName', _.get(toOrg, 'orgDisplayName'));
      saveEntitySessionData(
        'sessionData.applyForOrgName',
        _.get(forOrg, 'orgDisplayName')
      );

      //Check if user is part of ToOrg for validation
      this.permObj = _.reduce(
        this.props.auth.permissions,
        (result, permission) => {
          const [entityTypeId, orgRelationship, roleId] = permission.split(':');
          if (_.indexOf(result.types, entityTypeId) === -1) {
            result.entityTypes.push(entityTypeId);
          }
          if (_.indexOf(result.orgRelationship, orgRelationship) === -1) {
            result.orgRelationship.push(orgRelationship);
          }
          if (_.indexOf(result.roles, roleId) === -1) {
            result.roles.push(roleId);
          }
          return result;
        },
        {entityTypes: [], orgRelationship: [], roles: []}
      );

      let toOrgCheck = false;
      _.forEach(this.permObj.orgRelationship, (orgRel) => {
        const [orgId, progId, subOrgId] = orgRel.split('_');

        if (
          _.get(foData, 'programId') === Number(progId) &&
          orgId === applyToOrgId &&
          orgId === subOrgId
        ) {
          toOrgCheck = true;
        }
      });
      saveEntitySessionData('sessionData.withinToOrg', toOrgCheck);

      //Checking number of RFAs for ToOrg and FromOrg to be used in validation
      let rfaRequests = [];
      let numOfRfas = 0;
      rfaRequests.push(
        REST.dynamicData.getRfaStatusBySubOrganizationOrganizationFo({
          subOrgId: applyForOrgId,
          orgId: applyToOrgId,
          foId: _.get(foData, 'fundingOpportunityId'),
        })
      );

      return Promise.all(rfaRequests)
        .then((rfaResponses) => {
          return Promise.all(_.map(rfaResponses, (rfaRes) => rfaRes.json()));
        })
        .then((resJson) => {
          const rfaData = _.chain(resJson).map('rfa').flatten().value();
          if (rfaData[0] != undefined) numOfRfas = rfaData.length;
          saveEntitySessionData('sessionData.rfaForOrgIdSubOrgId', numOfRfas);
        })
        .catch((err) => {
          console.log('error', err);
        });
    }
  }

  render() {
    const {config, context, data, dynamicComponent} = this.props;
    const {foData} = this.state;
    let headerText;
    if (foData)
      headerText =
        foData.programId == 47
          ? 'Start a request for fire management assistance'
          : 'Start a request for assistance';
    return !_.isEmpty(this.props.context.orgs) ? (
      <Main>
        <Container id="rfaInit">
          <Header as="h1">{headerText}</Header>
          <Segment>
            {foData && <Header as="h2">{foData.fundingOpportunityName}</Header>}
            <React.Fragment>
              <div ref={this.handleContextRef}>
                {_.get(config, 'payload') ? (
                  <ContentDispatch
                    className="contentDispatch"
                    config={config.payload}
                    data={data}
                    context={context}
                    dynamicComponent={dynamicComponent}
                    handleSubmit={this.handleSubmit}
                  />
                ) : (
                  <Loader active inline="centered" />
                )}
              </div>
              <br />
              <Button
                color={'blue'}
                id={'id'}
                className={''}
                value={'value'}
                type={'type'}
                onClick={this.handleSubmit}
                disabled={
                  _.get(dynamicComponent, ['validationErrors', 'allValid'], false) ===
                  false
                }
                width={'medium'}
              >
                {'Start request'}
              </Button>
              <br />
              <br />
              <Link to="/">
                <Icon name="cancel" />
                Cancel
              </Link>
              <br />
              <br />
            </React.Fragment>
          </Segment>
          <br />
        </Container>
      </Main>
    ) : (
      <Loader active>Loading...</Loader>
    );
  }
}

export const mapStateToProps = (state) => {
  const {config, data, context, sessionData} = state.dynamicComponent;
  return {
    data,
    config,
    context,
    applyForOrgId: _.get(sessionData, 'applyForOrgId'),
    applyToOrgId: _.get(sessionData, 'applyToOrgId'),
    suborgs: _.get(sessionData, 'suborgs'),
    orgs: context.orgs,
    dynamicComponent: state.dynamicComponent,
    jwt: state.auth.token,
    auth: state.auth,
    userEntities: _.get(state, 'userEntities.entitiesData'),
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  init: (config, data, serviceCall) =>
    dispatch(DynamicComponentActions.init(config, data, serviceCall)),

  getConfig: (jwt, entityType, entityId, configType, configId) => {
    let action = ApiActions.config.getConfig(
      jwt,
      entityType,
      entityId,
      configType,
      configId
    );
    const res = dispatch(action);
    return res;
  },
  postDynamicData: (payload, token) => {
    const data = payload.data ? payload.data : payload;
    const dataPayload = JSON.stringify(_.omit(data, ['version']));
    let action = ApiActions.dynamicData.postData(token, dataPayload);
    const res = dispatch(action);
    return res;
  },
  organizations: (orgIds, token) => {
    const action = ApiActions.organization.getOrganizationsListById(token, orgIds);
    return dispatch(action);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(RfaInitializeComponent));
